import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "DocumentLineTools" }

import { PropType } from "vue";
import { Document, LineType, Line } from "@/types";
import DocumentLineTool from "@/components/pages/document/parts/DocumentLineTool.vue";
import api from "@/api";
import { useUiStore } from "@/stores/ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLineTools',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    lines: {
        type: Array as PropType<Line[]>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const createDocumentLine = (lineType: LineType) => {
    const rate = lineType === "count" ? props.document.rate : 0;
    const line: Line = {
        lineType,
        documentId: props.document.id,
        arrayOrder: props.lines.length,
        rate,
        hours: 0,
        text: "",
        amount: 0,
    };

    api.create(line, "documentLines").then((response) => {
        line.id = response.id;
        props.document.lines.push(line);
        uiStore.message("Post aangemaakt..");
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DocumentLineTool, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (createDocumentLine('count'))),
      title: "rekenmodel toevoegen",
      "icon-id": "ellipsis-h"
    }),
    _createVNode(DocumentLineTool, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (createDocumentLine('amount'))),
      title: "vast bedrag toevoegen",
      "icon-id": "euro-sign"
    }),
    _createVNode(DocumentLineTool, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (createDocumentLine('subtotal'))),
      title: "subtotal",
      "icon-id": "calculator"
    }),
    _createVNode(DocumentLineTool, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (createDocumentLine('text'))),
      title: "beschrijving toevoegen",
      "icon-id": "align-left"
    }),
    _createVNode(DocumentLineTool, {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (createDocumentLine('enter'))),
      title: "enter toevoegen",
      "icon-id": "paragraph"
    })
  ]))
}
}

})